var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Banner',{attrs:{"show":true,"text":_vm.$t(`main.searchResult.banner.${_vm.experience}Text`),"button-text":_vm.$t(`main.searchResult.banner.${_vm.experience}ButtonText`),"button-link":_vm.$urlBuilder('merch-plans', { keyword: 'listings' }),"use-nuxt-link":false,"bold-text":_vm.$t(`main.searchResult.banner.${_vm.experience}BoldText`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }